/** @jsx jsx */
import cx from 'classnames';
import { jsx, css } from '@emotion/react';

function CheckIcon({ className, ...props }: React.HTMLProps<HTMLElement>) {
  return (
    <i
      className={cx(className, 'fas', 'fa-check')}
      css={css`
        color: #27b3c1;
        font-size: 14px;
        padding-right: 18px;
      `}
      {...props}
    />
  );
}

export default CheckIcon;
